import { AuditableRecord } from "models/auditable-record/auditable-record";
import { PublishStatus } from "models/enumerations/publish-status/publish-status";
import { OrganizationEvent } from "models/interfaces/contracts/organization-event";

// -------------------------------------------------------------------------------------------------
// #region Default Values
// -------------------------------------------------------------------------------------------------

const defaultValues: OrganizationEvent = {
    enrollmentLimit: undefined,
    productId: undefined,
    productName: undefined,
    totalEnrollments: undefined,
    id: 0,
    name: "",
    status: undefined,
    instructorLedTrainingType: undefined,
    startDate: undefined,
    endDate: undefined,
    isMultipleDays: undefined,
};

// #endregion Default Values

// -------------------------------------------------------------------------------------------------
// #region Record
// -------------------------------------------------------------------------------------------------

class OrganizationEventRecord extends AuditableRecord(defaultValues) {
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: Partial<OrganizationEventRecord>) {
        params = params ?? Object.assign({}, defaultValues);


        super(params);
    }

    // #endregion Constructor

    // -------------------------------------------------------------------------------------------------
    // #region Public Methods
    // -------------------------------------------------------------------------------------------------
    public isLive(): boolean | undefined {
        if (this.status !== PublishStatus.Live) {
            return false;
        }

        const lastEventDate = this.endDate;
        if (lastEventDate == null) {
            return undefined;
        }

        const currentDate = new Date(new Date().toDateString());
        if (currentDate <= lastEventDate) {
            return true;
        } else {
            return false;
        }
    }
 
    // #endregion Public Methods
}

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { OrganizationEventRecord };

// #endregion Exports
